module.exports = __webpack_public_path__ + "img/red_vehicle.2909878b.svg";